import { createFileRoute } from '@tanstack/react-router'
import WebhooksGuard from 'Integration/components/webhooks/WebhooksGuard'

export const Route = createFileRoute('/integrations/_webhooks')({
    component: WebhooksGuard,
})
